<template>
  <div><!-- This component uses a render function --></div>
</template>

<script>
import { defineComponent, h } from 'vue';
import { createTemplateRenderer, testCompileFunction, clearTemplateCache } from '../Utils/TemplateRenderer.js';

export default defineComponent({
  name: 'CustomRuntimeTemplate',
  props: {
    template: {
      type: String,
      required: true
    },
    context: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { expose }) {
    // Test the compile function on setup
    testCompileFunction();
    
    // Expose methods for external access if needed
    expose({
      testCompileFunction,
      clearTemplateCache
    });
    
    return {};
  },
  render() {
    if (!this.template) {
      return h('div', 'No template provided');
    }

    // Create the template renderer
    const renderTemplate = createTemplateRenderer(this);
    
    // Create context from props and parent component data
    const context = {
      ...this.context,
      // Add common utility methods that might be needed
      translateField: this.$parent?.translateField || this.translateField,
      translate: this.$parent?.translate || this.translate,
      // Add any other methods from parent that might be needed
      ...(this.$parent?.$data || {}),
      ...(this.$parent?.$props || {})
    };

    try {
      return renderTemplate(this.template, context);
    } catch (error) {
      console.error('CustomRuntimeTemplate render error:', error);
      return h('div', {
        style: {
          padding: '10px',
          border: '1px solid #ff6b6b',
          borderRadius: '4px',
          backgroundColor: '#fff5f5',
          color: '#c53030'
        }
      }, `Template Error: ${error.message}`);
    }
  },
  methods: {
    // Fallback methods in case parent doesn't have them
    translateField(data) {
      const lang = window.appSettings?.appLanguage || 'en';
      if (!data) return '';
      if (typeof data[lang] !== 'undefined') return data[lang];
      if (typeof data['A0'] !== 'undefined') return data['A0'];
      return typeof data !== 'object' ? data : '';
    },
    translate(key) {
      return window.Lang?.get(key) ?? key;
    }
  }
});
</script>

<style scoped>
/* Ensure nested links (converted to spans) look and behave like links */
:deep(.nested-link) {
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}

:deep(.nested-link:hover) {
  opacity: 0.8;
}

/* Prevent image flicker during updates */
:deep(img) {
  max-width: 100%;
  height: auto;
}
</style>